var Themes = $.extend(false, BaseModule ,{
    api_route : 'themes',

    data : {
		module		: 'themes',
		page		: 1,
		limit		: 40,
		sort_term	: 'id',
		sort_way	: 'DESC',
        view        : 'grid',
        pagination  : true
	},

	init:function(){}
});

$(document).ready(function(){
	Themes.init();
});
